import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateShiftApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateShift = createAsyncThunk('updateShift', async (payload) => {
  return await updateShiftApi(payload);
});

const updateShiftSlice = createSlice({
  name: 'updateShift', // Unique Name
  initialState,
  reducers: {
    updateShiftReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateShift.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateShift.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateShift.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateShiftReset } = updateShiftSlice.actions;

export default updateShiftSlice.reducer;
